import { ILoggingService } from './interfaces';
import { ConsoleLoggerService } from './service';

export const LoggingServiceAdapter = (): ILoggingService => {
  const { logError, logInfo } = ConsoleLoggerService();

  return {
    logError,
    logInfo,
  };
};
